import { Component } from 'react'
import { AutocompleteHOC } from 'hocs'
import Suggest from 'components/ESSearch/Suggest'

class SuggestContainer extends Component {
  onSuggestionsFetchRequested = ({ value }) => {}

  getSuggestionValue = (suggestion) => suggestion

  render() {
    const { suggestions, value, handleSelect, handleClear, isFetching } =
      this.props
    const inputProps = {
      placeholder: 'Search Issue',
      value,
      onChange: this.props.onChange
    }

    const autosuggestProps = {
      inputProps,
      onSuggestionSelected: handleSelect,
      onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
      onSuggestionsClearRequested: this.props.onSuggestionsClearRequested,
      suggestions,
      getSuggestionValue: this.getSuggestionValue
    }
    const props = {
      autosuggestProps,
      clearHandler: handleClear,
      isFetching
    }

    return <Suggest {...props} />
  }
}

export default AutocompleteHOC(SuggestContainer)
